import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Box, Heading, Text } from 'grommet';

import BookElement from 'app/api/bookElement';

import Paragraph from 'app/components/Paragraph';
import SectionBreak from 'app/components/BookElements/SectionBreak';
import TableOfContentsEntry from 'app/components/BookElements/TableOfContentsEntry';

const Container = styled(Box)`
  text-align: center;
`;

const ItalicText = styled(Paragraph)`
  font-style: italic;
`;

class Supplement extends React.Component {
  render() {
    const { path, content } = this.props;
    if (BookElement.isNotSelected(path)) return null;
    return (
      <Container>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            Living Doctrine Supplement
          </Heading>
        </TableOfContentsEntry>
        <Text as="h3" alignSelf="start" size="large" weight="bold">
          Supplemental Content
        </Text>
        <Paragraph>
          This interactive digital publication (IDP) contains figure types and
          tables not included in the original publication.  The addition of new figures and tables may cause
          the numbering of the original figures and tables to change.
        </Paragraph>
        <ItalicText>
          [Bracketed, italicized text, as shown here, indicates that the text is
          supplemental text.]
        </ItalicText>
        <Paragraph>
          Updates to publications cited in this IDP are also included in this
          doctrine supplement. Updated publications appear inline and are
          denoted by bracketed, italicized text as the supplemental text shown
          above. Updated publications listed in the References section appear in
          brackets only. The outdated publications have been removed from the
          IDP.
        </Paragraph>
        {content.details && <Paragraph>{content.details}</Paragraph>}
        <SectionBreak />
      </Container>
    );
  }
}

Supplement.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * details
   */
  content: PropTypes.shape({
    details: PropTypes.string,
  }),
};
Supplement.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(Supplement));
Component.displayName = 'Supplement';
export const SupplementComponent = Supplement;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Supplement.js